import { render, staticRenderFns } from "./audios.vue?vue&type=template&id=77811df0&scoped=true&"
import script from "./audios.vue?vue&type=script&lang=js&"
export * from "./audios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77811df0",
  null
  
)

export default component.exports